import cx from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { useBreakpoints } from '@/utils/useBreakpoints'

import { useMenu } from './menu/menu-provider'
import { useGameSlug } from '../../game-provider'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './categoryLinks.module.scss'

type NavLink = {
  href: string
  label: string
}

const NavLink: React.FC<{
  link: NavLink
  isActive: boolean
}> = ({ link, isActive }) => {
  const gameSlug = useGameSlug()
  const { setIsOpen } = useMenu()
  const from = useBreakpoints().from
  const isDesktop = from('laptop-small')

  const categoryImage = `/images/${gameSlug}/cat-${link.href.replace('#', '')}.png`

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey) {
      return
    }

    if (!isDesktop) {
      setIsOpen(false)
    }
    const element = window.location.hash && document.querySelector(window.location.hash)
    if (!element) return
    element.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div key={link.href} className={cx(styles.link, { [styles.isActive]: isActive })}>
      <Link href={link.href} scroll={false} passHref onClick={handleClick}>
        {!isDesktop && <Image src={categoryImage} alt={link.label} width={52} height={52} quality={100} />}
        <StoreTypography tag="h3" textSize="md" style="outlined" lineHeight="normal" className={styles.linkLabel}>
          {link.label}
        </StoreTypography>
      </Link>
    </div>
  )
}

export const CategoryLinks: React.FC<{
  categories: NavLink[]
}> = ({ categories }) => {
  const { asPath } = useRouter()

  return (
    <div className={cx(styles.categoryLinks)}>
      {categories.map((link) => (
        <NavLink key={link.href} link={link} isActive={link.href.includes(asPath) && asPath !== '/'} />
      ))}
    </div>
  )
}
